import { h, Component } from 'preact';
import { accessNested } from 'utils/utils';
import { getCopy } from 'utils/copy';
import formatDateTime from 'utils/formatDateTime';
import { getTicketsText } from 'store/ticketingPublic';
import s from 'components/shared/theaters/ticketing/ticketComplete/ticket.sss';


export default class Ticket extends Component {

	render(props) {
		const {
			ticketing
		} = props;

		const movieTitle  = accessNested(ticketing, 'meta.movieTitle', 'Movie title');
		const movieFormat = accessNested(ticketing, 'meta.movieFormat');
		const movieDate   = accessNested(ticketing, 'meta.movieDate');
		const bookingRef  = accessNested(ticketing, 'payment.bookingId', '-');
		const ticketsText = getTicketsText(ticketing.tickets);
		const seats       = ticketing.seats;

		let format = null;
		if (movieFormat) {
			format = <small>({movieFormat})</small>;
		}

		let date = null;
		if (movieDate) {
			date = formatDateTime(movieDate, 'dddd d, MMMM - h:mmtt', getCopy('DATETIME_LOCALE'));
		}

		return (
			<div class={s.ticketContainer} id="ticket">
				<div class={s.ticketGutter}>
					<div class={s.ticketScroller}>
						<div class={s.ticket}>
							<div class={s.ticketPunctureLeft}></div>
							<div class={s.ticketPunctureRight}></div>
							<div class={s.ticketOnesheet}></div>
							<div class={s.ticketDetails}>
								<h2 class={s.ticketMovieTitle}>{movieTitle} {format}</h2>
								<p class={s.ticketMovieDate}>{date}</p>
								<hr />
								<p class={s.ticketBookingRef}>{getCopy('BOOKING_REFERENCE')}: <strong>{bookingRef}</strong></p>
								<p class={s.ticketRecap}>{ticketsText}</p>
								{ticketing.seatingSupported && (
									<div class={s.ticketGrid}>
										{seats.map(({ label }) => <div class={s.ticketSeat}>{label}</div>)}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

}
